import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class PriorityButtonComponent implements IController {
  priority: any;
  isDisabled: any;
  onChange: Function;

  PRIORITY_OPTIONS: any;
  selectedPriority = {};
  options: any[] = [];

  constructor(private commonsConstants) {
  }

  $onInit() {
    this.PRIORITY_OPTIONS = this.commonsConstants.priorities;
    this.options = this.PRIORITY_OPTIONS;
    this.selectedPriority = _.find(this.options, (o) => {
      return o.key === this.priority;
    });
  }


  $onChanges(changes) {
    if (changes.priority && !changes.priority.isFirstChange()) {
      this.selectedPriority = _.find(this.options, (o) => {
        return o.key === this.priority;
      });
    }
  };

  onSelect(priority) {
    this.onChange({priority: priority})
  }

  onOpen($mdMenu) {
    this.options = this.PRIORITY_OPTIONS;
    $mdMenu.open();
  }

  onClose($mdMenu) {
    this.options = [];
    $mdMenu.close()
  }

}

angular
  .module('bringoz.admin.commons')
  .component('priorityButton', {
    bindings: {
      priority: '<',
      isDisabled: '<?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/priority-button/priority-button.html',
    controller: PriorityButtonComponent
  });
